import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Typography,
  Box,
  Paper,
  IconButton,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SlotActionModal = ({
  open,
  onClose,
  slotInfo,
  handleCancelAppointment,
  onReschedule,
}) => {
  const [actionType, setActionType] = useState("");

  const handleConfirm = () => {
    // if (actionType === "cancel") {
    //   handleCancelAppointment(slotInfo.appointment_id);
    //   onClose();
    //   setActionType("");
    // }
    if (actionType === "cancel") {
      handleCancelAppointment(slotInfo.appointment_id);
    } else if (actionType === "reschedule") {
      onReschedule(slotInfo);
    }
    onClose();
    setActionType("");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          width: "100%",
          maxWidth: 600,
          boxShadow: "0 6px 18px rgba(0,0,0,0.18)",
        },
      }}
    >
      {/* Title */}
      <DialogTitle
        sx={{
          backgroundColor: "#213360",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: "#fff",
            fontWeight: 500,
            fontSize: "1.1rem",
          }}
        >
          Manage Appointment
        </Typography>
        <IconButton
          onClick={() => {
            setActionType("");
            onClose();
          }}
        >
          <CloseIcon sx={{ color: "#fff" }} />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent sx={{ mt: 1.5 }}>
        {/* Slot Info Summary */}
        {slotInfo && (
          <Paper
            elevation={0}
            sx={{
              mt: 1,
              p: 2,
              border: "1px solid #21cdc0",
              borderRadius: "10px",
              backgroundColor: "#EBFAF9",
            }}
          >
            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={12} sm={6}>
                <Box display="flex" flexDirection="column" rowGap={0.5}>
                  <Box
                    display="flex"
                    // alignItems="center"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, minWidth: 95 }}
                    >
                      Patient Name
                    </Typography>

                    <Typography variant="body2">
                      <span style={{ fontWeight: 600 }}>: </span>
                      {slotInfo?.patient_name || "—"}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    // alignItems="center"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, minWidth: 95 }}
                    >
                      Patient ID
                    </Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: 600 }}>: </span>
                      {slotInfo?.patient_id || "—"}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    // alignItems="center"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, minWidth: 95 }}
                    >
                      Slot
                    </Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: 600 }}>: </span> #
                      {slotInfo?.slot_number || "—"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Box display="flex" flexDirection="column" rowGap={0.5}>
                  <Box
                    display="flex"
                    // alignItems="center"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, minWidth: 125 }}
                    >
                      Appointment Date
                    </Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: 600 }}>: </span>
                      {slotInfo?.slot_date || "—"}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    // alignItems="center"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, minWidth: 125 }}
                    >
                      Slot Timings
                    </Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: 600 }}>: </span>
                      {slotInfo?.slot_start_time} - {slotInfo?.slot_end_time}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        )}

        {/* Radio Options */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 2, mb: 0.5, fontWeight: 500 }}
        >
          What would you like to do with this booked appointment?
        </Typography>

        <FormControl component="fieldset" sx={{ width: "100%" }}>
          <RadioGroup
            value={actionType}
            onChange={(e) => setActionType(e.target.value)}
            row // makes radio options in same line
          >
            <FormControlLabel
              value="cancel"
              control={<Radio color="primary" />}
              label={
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Cancel
                </Typography>
              }
              sx={{ mr: 4 }} // spacing between radios
            />
            <FormControlLabel
              value="reschedule"
              control={<Radio color="primary" />}
              label={
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Reschedule
                </Typography>
              }
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>

      {/* Actions */}
      <DialogActions>
        <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
          <Button
            variant="contained"
            sx={{
              borderRadius: "10px",
              backgroundColor: "#121959",
              color: "#fff",
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 1 },
              "&:hover": {
                backgroundColor: "#121959",
              },
            }}
            onClick={() => {
              setActionType("");
              onClose();
            }}
            size="small"
          >
            Close
          </Button>

          <Button
            variant="contained"
            disabled={!actionType}
            sx={{
              borderRadius: "10px",
              backgroundColor: "#121959",
              color: "#fff",
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 1 },
              "&:hover": {
                backgroundColor: "#121959",
              },
            }}
            onClick={handleConfirm}
            size="small"
          >
            Done
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default SlotActionModal;
